export default {
  SEARCH_CATALOG_ALLIANZ_COUNTRY_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_COUNTRY_QUERY'),
  CATALOG_ALLIANZ_COUNTRY_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_COUNTRY_REPOSITORY'),
  CATALOG_ALLIANZ_COUNTRY_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_COUNTRY_STATE_MANAGER'),
};
